import { useRef, useState } from "react";
import { FileText, UploadCloud } from "lucide-react";
import { MAX_BOOK_SIZE } from "../constants";

type DropzoneProps = {
  onFile: (file: File) => void;
  compact?: boolean;
};

export function Dropzone({ onFile, compact = false }: DropzoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);

  function accept(files: FileList | null) {
    const file = files?.[0];
    if (file) onFile(file);
  }

  return (
    <div
      className={`dropzone ${dragging ? "is-dragging" : ""} ${compact ? "is-compact" : ""}`}
      onDragEnter={(event) => {
        event.preventDefault();
        setDragging(true);
      }}
      onDragOver={(event) => event.preventDefault()}
      onDragLeave={(event) => {
        if (event.currentTarget === event.target) setDragging(false);
      }}
      onDrop={(event) => {
        event.preventDefault();
        setDragging(false);
        accept(event.dataTransfer.files);
      }}
    >
      <input
        ref={inputRef}
        hidden
        type="file"
        accept="application/pdf,application/epub+zip,.pdf,.epub"
        onChange={(event) => accept(event.target.files)}
      />
      <div className="drop-icon">
        {compact ? <FileText size={21} /> : <UploadCloud size={28} />}
      </div>
      <div>
        <strong>{compact ? "Başka bir kitap aç" : "PDF veya EPUB’ını buraya bırak"}</strong>
        {!compact && (
          <p>
            Kitabın yalnızca cihazında işlenir ve yerel arşivine kaydedilir.
          </p>
        )}
      </div>
      <button className="secondary-button" onClick={() => inputRef.current?.click()}>
        Dosya seç
      </button>
      {!compact && <small>PDF veya EPUB · En fazla {MAX_BOOK_SIZE / 1024 / 1024} MB</small>}
    </div>
  );
}
